import { createContext } from 'react';
import { UseSuspenseQueryResult } from '@tanstack/react-query';
import { PaginatedData } from 'types/pagination';
import { FilterParams } from 'types/params';

interface ITableCoreStateContext<T> {
    search?: string;
    setSearch?: (value: string) => void;
    enableSchema?: boolean;
    params?: FilterParams;
    query?: UseSuspenseQueryResult<PaginatedData<T>>;
    isPending?: boolean;
}

const TableCoreStateContext = createContext<ITableCoreStateContext<any>>({});

export { TableCoreStateContext };
export type { ITableCoreStateContext };
